/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import axios from "axios";
import Cookies from "js-cookie";

export function* callApiServiceCommon(payload) {
  const url = payload.url;
  const method = payload.method;
  const params = payload.params;
  // POST
  if (method === "POST") {
    if (typeof params !== "object") {
      return yield;
    }
    const Array = Object.keys(params);
    const bodyFormData = new FormData();
    yield Array.forEach((element) => {
      bodyFormData.append(element, params[element]);
    });
    return yield axios({
      method,
      url,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: Cookies.get("autoketing_product_review_session"),
      },
    })
      .then((response) => {
        return response.status === 200 ? response.data : "";
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // GET
  return yield axios({
    method: "get",
    url,
    params,
    headers: {
      Authorization: Cookies.get("autoketing_product_review_session"),
    },
  })
    .then(function (response) {
      return response.status === 200 ? response.data : [];
    })
    .catch(function () {
      return [];
    });
}
